<template>
  <gg-btn primary class="float-right" :loading="loading" @click="clearAllNotifications" v-if="location === 'history'">
    Dismiss all
  </gg-btn>
  <div class="text-right pt-2 pr-1" v-else>
    <v-btn text color="primary" @click="clearAllNotifications">Dismiss All</v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DismissAll',
  props: {
    location: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
    }
  },
  methods: {
    ...mapActions({
      dismissAll: 'notifications/dismissAll',
      reportError: 'reportError'
    }),
    async clearAllNotifications () {
      try {
        await this.dismissAll()
        this.$emit('update')
      } catch (e) {
        this.reportError(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
//@import "src/assets/scss/app.variables";

//.dismiss-all {
//  text-transform: uppercase;
//  font-weight: 500;
//  transition: color 0.3s ease;
//
//  &:hover {
//    color: $primary !important;
//  }
//}
</style>
